import axios from "axios";
import { Cookies } from "react-cookie";
import { message } from "antd";
import { KeysToCamel, KeysToSnake } from "scripts/helpers";

const _cookies = new Cookies();
const _cookiePath =
	process.env.NODE_ENV === "production"
		? process.env.REACT_APP_COOKIE_PATH
		: window.location.hostname;

axios.defaults.baseURL = process.env.REACT_APP_API_URL;
axios.defaults.headers.common["Authorization"] = `Bearer ${
	_cookies.get(process.env.REACT_APP_COOKIE_TOKEN) || ""
}`;
//axios.defaults.headers.common['Access-Control-Allow-Credentials'] = true;
//axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

const delCookie = () => {
	_cookies.remove(process.env.REACT_APP_COOKIE_TOKEN, {
		path: "/",
		domain: _cookiePath,
	});
	axios.defaults.headers.common["Authorization"] = "";
};

const getCookie = () => {
	return _cookies.get(process.env.REACT_APP_COOKIE_TOKEN);
};
const getTheme = () => {
	return _cookies.get(process.env.REACT_APP_THEME_COOKIE_TOKEN);
};

const setCookie = (token, expire) => {
	const date = new Date();
	date.setDate(date.getDate() + expire);
	_cookies.set(process.env.REACT_APP_COOKIE_TOKEN, token, {
		path: "/",
		expires: date,
		domain: _cookiePath,
	});
	window.location = "/";
};

const setTheme = (theme, expire) => {
	const date = new Date();
	date.setDate(date.getDate() + expire);
	_cookies.set(process.env.REACT_APP_THEME_COOKIE_TOKEN, theme, {
		path: "/",
		expires: date,
		domain: _cookiePath,
	});
};

const handleError = (response) => {
	if (response.data?.message) message.error(response.data.message);

	switch (response.status) {
		case 400:
			if (response.data?.errors)
				response.data?.errors.forEach((o) => message.error(o.message));
			break;
		case 403:
			break;
		case 404:
			break;
		case 405:
			break;
		case 422:
			break;
		case 500:
			break;
		default:
			window.location = "/auth/login";
			break;
	}
};

const get = (url, params = {}) => {
	return new Promise((resolve, reject) => {
		axios
			.get(url, { params: KeysToSnake(params), validateStatus: false })
			.then((response) => {
				if (response.status === 200) {
					resolve(KeysToCamel(response.data));
				} else {
					handleError(response);
					reject(response.data);
				}
			});
	});
};

const post = (url, params = {}) => {
	return new Promise((resolve, reject) => {
		axios
			.post(url, KeysToSnake(params), { validateStatus: false })
			.then((response) => {
				if (response.status === 200) {
					message.success(response.data.message);
					resolve(KeysToCamel(response.data));
				} else {
					handleError(response);
					reject(response.data);
				}
			});
	});
};

const put = (url, params = {}) => {
	return new Promise((resolve, reject) => {
		axios
			.put(url, KeysToSnake(params), { validateStatus: false })
			.then((response) => {
				if (response.status === 200) {
					message.success(response.data.message);
					resolve(KeysToCamel(response.data));
				} else {
					handleError(response);
					reject(response.data);
				}
			});
	});
};

const del = (url, params = {}) => {
	return new Promise((resolve, reject) => {
		axios
			.delete(url, { params: KeysToSnake(params), validateStatus: false })
			.then((response) => {
				if (response.status === 200) {
					message.success(response.data.message);
					resolve(KeysToCamel(response.data));
				} else {
					handleError(response);
					reject(response.data);
				}
			});
	});
};

const formData = (url, params = {}, progress) => {
	return new Promise((resolve, reject) => {
		axios
			.post(url, params, {
				validateStatus: false,
				headers: { "Content-Type": "multipart/form-data" },
				onUploadProgress: (e) => {
					if (progress) progress(Math.floor((e.loaded / e.total) * 100));
				},
			})
			.then((response) => {
				if (response.status === 200) {
					message.success(response.data.message);
					resolve(KeysToCamel(response.data));
				} else {
					handleError(response);
					reject(response.data);
				}
			});
	});
};

const dataCenterUpload = (url, params = {}, progress) => {
	return new Promise((resolve, reject) => {
		axios
			.post(url, params, {
				validateStatus: false,
				headers: {
					"Content-Type": "multipart/form-data",
					"Upload-Access-Token":
						"9qTltnsfeY2bMyNfEoEenkEq6wsfskvzsq4iqgadwKTsR6paarpCKQey3dcmfkzw4EGEQJOQEZKnvwAuTd1ejA5qyDWAgz0xjtiQVMZ30hlMGtC78mgSXSY25G9I5msX",
				},
				baseURL: process.env.REACT_APP_DATACENTER_URL,
				onUploadProgress: (e) => {
					if (progress) progress(Math.floor((e.loaded / e.total) * 100));
				},
			})
			.then((response) => {
				if (response.status === 200) {
					message.success(response.data.message);
					resolve(KeysToCamel(response.data));
				} else {
					handleError(response);
					reject(response.data);
				}
			});
	});
};

export default {
	dashboard: () => {
		return get("panel/dashboard");
	},
	permissions: () => {
		return get("panel/permissions");
	},
	transactions: (params) => {
		return get("panel/transactions", params);
	},
	about: {
		details: () => {
			return get("panel/about-us");
		},
		update: (params) => {
			return put("panel/about-us", params);
		},
	},
	auth: {
		getOtp: (params) => {
			return post("auth/get-otp", params);
		},
		login: (params) => {
			return post("auth/login-password", params);
		},
		loginOtp: () => {
			return post("auth/login-otp");
		},
		logout: () => {
			return get("auth/logout");
		},
		me: () => {
			return get("auth/me");
		},
		passReset: (params) => {
			return post("auth/pass-reset", params);
		},
	},
	banner: {
		create: (params) => {
			return post("panel/banners", params);
		},
		delete: (id) => {
			return del(`panel/banners/${id}`);
		},
		details: (id) => {
			return get(`panel/banners/${id}`);
		},
		list: (params) => {
			return get("panel/banners", params);
		},
		status: (id) => {
			return get(`panel/banners/${id}/status`);
		},
		update: (id, params) => {
			return put(`panel/banners/${id}`, params);
		},
	},
	category: {
		create: (params) => {
			return post("panel/categories", params);
		},
		delete: (id) => {
			return del(`panel/categories/${id}`);
		},
		details: (id) => {
			return get(`panel/categories/${id}`);
		},
		list: (params) => {
			return get("panel/categories", params);
		},
		listSubs: (params, id) => {
			return get(`panel/categories/${id}/subs`, params);
		},
		update: (id, params) => {
			return put(`panel/categories/${id}`, params);
		},
		status: (id) => {
			return get(`panel/categories/${id}/status`);
		},
	},
	contact: {
		details: () => {
			return get("panel/contact-us");
		},
		update: (params) => {
			return put("panel/contact-us", params);
		},
	},
	coupon: {
		create: (params) => {
			return post("panel/coupons", params);
		},
		delete: (id) => {
			return del(`panel/coupons/${id}`);
		},
		details: (id) => {
			return get(`panel/coupons/${id}`);
		},
		list: (params) => {
			return get("panel/coupons", params);
		},
		status: (id) => {
			return get(`panel/coupons/${id}/status`);
		},
		update: (id, params) => {
			return put(`panel/coupons/${id}`, params);
		},
	},
	course: {
		attach: (params, id) => {
			return get(`panel/courses/${id}/atach`, params);
		},
		create: (params) => {
			return post("panel/courses", params);
		},
		delete: (id) => {
			return del(`panel/courses/${id}`);
		},
		details: (id) => {
			return get(`panel/courses/${id}`);
		},
		list: (params) => {
			return get("panel/courses", params);
		},
		reorder: (params) => {
			return put(`panel/courses/reorder`, params);
		},
		update: (id, params) => {
			return put(`panel/courses/${id}`, params);
		},
		status: (id) => {
			return get(`panel/courses/${id}/status`);
		},
	},
	faq: {
		create: (params) => {
			return post("panel/faqs", params);
		},
		delete: (id) => {
			return del(`panel/faqs/${id}`);
		},
		details: (id) => {
			return get(`panel/faqs/${id}`);
		},
		list: (params) => {
			return get("panel/faqs", params);
		},
		reorder: (params) => {
			return put(`panel/faqs/reorder`, params);
		},
		status: (id) => {
			return get(`panel/faqs/${id}/status`);
		},
		update: (id, params) => {
			return put(`panel/faqs/${id}`, params);
		},
	},
	files: {
		create: (params, progress) => {
			return formData("panel/files", params, progress);
		},
		delete: (id) => {
			return del(`panel/files/${id}`);
		},
		list: (params) => {
			return get("panel/files", params);
		},
		update: (id, params, progress) => {
			return formData(`panel/files/${id}`, params, progress);
		},
	},
	gallery: {
		create: (params, progress) => {
			return formData("gallery", params, progress);
		},
		delete: (id) => {
			return del(`gallery/${id}`);
		},
		list: (params) => {
			return get("gallery", params);
		},
		update: (id, params, progress) => {
			return formData(`gallery/${id}`, params, progress);
		},
	},
	job: {
		create: (params) => {
			return post("panel/jobs", params);
		},
		delete: (id) => {
			return del(`panel/jobs/${id}`);
		},
		details: (id) => {
			return get(`panel/jobs/${id}`);
		},
		list: (params) => {
			return get("panel/jobs", params);
		},
		update: (id, params) => {
			return put(`panel/jobs/${id}`, params);
		},
	},
	notification: {
		create: (params) => {
			return post("panel/notifications", params);
		},
		delete: (id) => {
			return del(`panel/notifications/${id}`);
		},
		details: (id) => {
			return get(`panel/notifications/${id}`);
		},
		list: (params) => {
			return get("panel/notifications", params);
		},
		status: (id) => {
			return get(`panel/notifications/${id}/status`);
		},
		update: (id, params) => {
			return put(`panel/notifications/${id}`, params);
		},
	},
	package: {
		create: (params) => {
			return post("panel/packages", params);
		},
		delete: (id) => {
			return del(`panel/packages/${id}`);
		},
		details: (id) => {
			return get(`panel/packages/${id}`);
		},
		list: (params) => {
			return get("panel/packages", params);
		},
		update: (id, params) => {
			return put(`panel/packages/${id}`, params);
		},
		status: (id) => {
			return get(`panel/packages/${id}/status`);
		},
	},
	platform: {
		create: (params) => {
			return post("panel/platforms", params);
		},
		details: (id) => {
			return get(`panel/platforms/${id}`);
		},
		delete: (id) => {
			return del(`panel/platforms/${id}`);
		},
		list: (params) => {
			return get("panel/platforms", params);
		},
		status: (id) => {
			return get(`panel/platforms/${id}/status`);
		},
		update: (id, params) => {
			return put(`panel/platforms/${id}`, params);
		},
	},
	role: {
		create: (params) => {
			return post("panel/roles", params);
		},
		delete: (id) => {
			return del(`panel/roles/${id}`);
		},
		details: (id) => {
			return get(`panel/roles/${id}`);
		},
		list: (params) => {
			return get("panel/roles", params);
		},
		permissions: (id) => {
			return get(`panel/roles/${id}/permissions`);
		},
		update: (id, params) => {
			return put(`panel/roles/${id}`, params);
		},
	},
	sample: {
		create: (params) => {
			return post("panel/samples", params);
		},
		delete: (id) => {
			return del(`panel/samples/${id}`);
		},
		details: (id) => {
			return get(`panel/samples/${id}`);
		},
		list: (params) => {
			return get("panel/samples", params);
		},
		status: (id) => {
			return get(`panel/samples/${id}/status`);
		},
		update: (id, params) => {
			return put(`panel/samples/${id}`, params);
		},
	},
	session: {
		create: (params) => {
			return post("panel/course-sessions", params);
		},
		delete: (id) => {
			return del(`panel/course-sessions/${id}`);
		},
		details: (id) => {
			return get(`panel/course-sessions/${id}`);
		},
		list: (params) => {
			return get("panel/course-sessions", params);
		},
		reorder: (params) => {
			return put(`panel/course-sessions/reorder`, params);
		},
		status: (id) => {
			return get(`panel/course-sessions/${id}/status`);
		},
		update: (id, params) => {
			return put(`panel/course-sessions/${id}`, params);
		},
	},
	setting: {
		details: () => {
			return get(`panel/settings`);
		},
		update: (params) => {
			return put(`panel/settings`, params);
		},
	},
	tac: {
		details: () => {
			return get("panel/tac");
		},
		update: (params) => {
			return put("panel/tac", params);
		},
	},
	videos: {
		create: (params, progress) => {
			return formData("panel/session-videos", params, progress);
		},
		delete: (id) => {
			return del(`panel/session-videos/${id}`);
		},
		list: (params) => {
			return get("panel/session-videos", params);
		},
		update: (id, params, progress) => {
			return formData(`panel/session-videos/${id}`, params, progress);
		},
	},
	user: {
		create: (params) => {
			return post("panel/users", params);
		},
		delete: (id) => {
			return del(`panel/users/${id}`);
		},
		details: (id) => {
			return get(`panel/users/${id}`);
		},
		list: (params) => {
			return get("panel/users", params);
		},
		update: (id, params) => {
			return put(`panel/users/${id}`, params);
		},
		status: (id) => {
			return get(`panel/users/${id}/status`);
		},
		course: (id, params) => {
			return put(`panel/users/${id}/attach-course`, params);
		},
		role: (id, params) => {
			return put(`panel/users/${id}/change-role`, params);
		},
	},
	version: {
		create: (params) => {
			return post("panel/versions", params);
		},
		details: (id) => {
			return get(`panel/versions/${id}`);
		},
		delete: (id) => {
			return del(`panel/versions/${id}`);
		},
		list: (params) => {
			return get("panel/versions", params);
		},
		update: (id, params) => {
			return put(`panel/versions/${id}`, params);
		},
	},
	formData,
	dataCenterUpload,
	delCookie,
	getCookie,
	getTheme,
	setCookie,
	setTheme,
};
